import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { addCarService, getSingleCarService, updateCarService } from '../../actions'
import axios from 'axios'

export default function AddCarService(){
    const dispatch = useDispatch()
    const [addCategory, setAddCategory] = useState({
        service: "",
        priority: '',
        active: '',
        imageId:'',
        image:""
    })
 
    const [dataEdit, setDataEdit] = useState(false)
    const [image, setImage] = useState({})
  const [mediaID, setMediaID] = useState('')

    const {carService} = useParams()

    const onHandleChange = (e) => {
        const {name, value} = e.target;
        setAddCategory({...addCategory, [name]:value})
    }

    const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('loged_In_auth'),
        },
    };
    const uploadMedia = (e) => {
        console.log("media", e.target.files[0]);
        const file = e.target.files[0]
    
        const reader = new FileReader(file)
        reader.readAsDataURL(file);
        // console.log("result", reader);
        if(file !== undefined){
          reader.onloadend = () => {
              setImage({
                mimeType: reader.result
              })
              console.log("result", image);
          }
        }
        let data = new FormData()
    
        data.append('media', file)
        console.log("datadata", data);
    
        axios
          .post('https://caravenue.infoware.xyz/api/media/new', data, config)
    
          .then(res => {
            console.log("responsehtisis", res.data.response.media[0]?.mediaId);
            setImage(res.data.response.media[0])
            setMediaID(res.data.response.media[0]?.mediaId)
          })
          .catch(err => {
            console.log(err);
          })
    }

    const location = window.location.href.split('/')[6]

    useEffect(() => {
        if(location==="Update"){
            dispatch(getSingleCarService(carService))
            setDataEdit(true)
        }
    },[location])

    const singleData = useSelector(state => state.home.singleServiceData)?.response

    console.log("addCategoryasdasd", singleData);

    useEffect(() => {
        if(location==="Update"){
            setAddCategory({
                service: singleData?.service,
                priority: singleData?.priority,
                active: singleData?.active,
                imageId: singleData?.imageId,
                
            })
        } else if (location ==="CarService"){
            setAddCategory({
                service: '',
                priority: '',
                active: '',
            })
        }
    },[singleData])

    const onSave = () => {
        if(dataEdit){
            const payload = {
                serviceId: singleData.serviceId,
                service:addCategory.service,
                active:addCategory.active,
                priority:addCategory.priority,
                imageId: mediaID
            }
            console.log("payload",payload);
            dispatch(updateCarService(payload))
        } else {
            const payload = {
                service:addCategory.service,
                active:addCategory.active,
                priority:addCategory.priority,
                imageId: mediaID
            }
            // console.log("payload",payload);
            dispatch(addCarService(payload))
        }
    }
    console.log("mediaID",mediaID);
    return (
        <>
            <div className=''>
				<div className='col-md-6'>
					<div className='form-group row'>
						<div className='col-sm-9'></div>
					</div>
				</div>
				<div className='m-4'>
				<h1>Add Car Services</h1>
                </div>

                <div className='card-body'>
                    
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group row'>
                            <label className='col-sm-3 col-form-label'>
                                Business Category
                            </label>
                            <div className='col-sm-9'>
                                <input
                                    type='text'
                                    className='form-control'
                                    name='service'
                                    id='service'
                                    placeholder='Business Category'
                                    onChange={onHandleChange}
                                    value={addCategory.service}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group row'>
                            <label className='col-sm-3 col-form-label'>
                                Priority
                            </label>
                            <div className='col-sm-9'>
                                <input
                                    type='text'
                                    className='form-control'
                                    name='priority'
                                    id='BusinessCategory'
                                    placeholder='Priority'
                                    onChange={onHandleChange}
                                    value={addCategory.priority}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group row'>
                            <label className='col-sm-3 col-form-label'>
                                Status
                            </label>
                            <div className='col-sm-9'>
                                <select
                                    name='active'
                                    onChange={onHandleChange}
                                    className='form-control'
                                    value={addCategory.active}
                                    >
                                    <option>Select Status</option>
                                    <option value={true}>Active</option>
                                    <option value={false}>Inactive</option>
                                </select>

                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                            <div className='row'>
                              <div className='col-sm-3'>Icon Image</div>
                              <div className='col-sm-9'>
                                <form
                                  id='userImage'
                                  name='userImage'
                                  encType='multipart/form-data'
                                  className='text-capitalize'>
                                  <div className='form-group'>
                                    <input
                                      accept='image/*'
                                      onChange={uploadMedia}
                                      id='banner_image'
                                      type='file'
                                      className='form-control'
                                      autoComplete='off'
                                      name='media'
                                      data-toggle='tooltip'
                                      title='Click To Upload Photo'
                                    />
                                    <div id='banner_image_lable' className='pt-2'>
                                      
                                          <img
                                            // src={addCategory.image}``
                                            alt=''
                                            className='img-100'
                                            onError={e => {
                                              e.target.src = '';
                                            }}
                                          />
                                        
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                            </div>
                </div>
                <div className='card-footer'>
						<div className='row float-right p-3'>
							<button onClick={onSave} className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> Save
							</button>
							{/* )} */}
							<Link
								to={'/ServiceTypeMaster/CarService'}
								className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
                </div>
            </div>
                
        </>
    )
}